import { Container } from "./Container";
import { Section } from "./Section";
import { Title } from "./Title";

export const BaseView = Object.assign(Container, {
  Section,
  Title,
});
